export interface RoleReflectionInterface {
  /**
   * 姓名
   */
  name: string
  photo?: string | null
  avatar?: string | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
}

export class RoleReflection implements RoleReflectionInterface {
  /**
   * 姓名
   */
  name: string
  photo?: string | null
  avatar?: string | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number

  constructor(props: RoleReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      photo: _photo,
      avatar: _avatar,
      id: _id,
      schoolId: _schoolId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.photo = _photo
    this.avatar = _avatar
    this.id = _id
    this.schoolId = _schoolId
  }
}
